module.exports = __webpack_public_path__ + "static/img/2_1_3.bbde50d2.jpg";